import type React from 'react';
import type { ComponentType } from 'react';

import { cn } from '@change/ds-utils';

type Size = 'small' | 'medium' | 'large';

type Props = Readonly<{
	Icon: ComponentType<{ size?: number }>;
	size: Size;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'data-qa': string;
}>;

// the canvases' 48/64/72px tiles holding 26/36/40px icons
const SIZES: Readonly<Record<Size, { tileClassName: string; iconSize: number }>> = {
	small: { tileClassName: 'size-12', iconSize: 26 },
	medium: { tileClassName: 'size-16', iconSize: 36 },
	large: { tileClassName: 'size-18', iconSize: 40 },
};

/** The tinted, decorative square that frames a card's design-system icon. */
export const IconTile: React.FC<Props> = ({ Icon, size, 'data-qa': dataQa }) => {
	const { tileClassName, iconSize } = SIZES[size];

	return (
		<div
			aria-hidden="true"
			className={cn(
				'bg-fill-selected-weaker text-icon-information flex shrink-0 items-center justify-center rounded-lg',
				tileClassName,
			)}
			data-qa={dataQa}
		>
			<Icon size={iconSize} />
		</div>
	);
};
